<template>
  <div :class="[`text-${field.textAlign}`, ...(field.classes ?? [])]">
    <template v-if="fieldValue">
      <CopyButton
        v-if="fieldValue && field.copyable && !shouldDisplayAsHtml"
        @click.prevent.stop="copy"
        v-tooltip="__('Copy to clipboard')"
      >
        <span ref="theFieldValue">
          {{ fieldValue }}
        </span>
      </CopyButton>
      <ExternalLinkButton
            v-else-if="fieldValue && field.copyable && shouldDisplayAsHtml"
            v-tooltip="'Open in new window'"
      >
        <span ref="theFieldValue">
          <!-- A tricky hack to implement an External Link icon without adding more props -->
          {{ fieldValue }}
        </span>
      </ExternalLinkButton>

      <span
        v-else-if="fieldValue && !field.copyable && !shouldDisplayAsHtml"
        class="whitespace-nowrap"
      >
        {{ fieldValue }}
      </span>
      <div
        @click.stop="check_iframe_hack"
        v-else-if="fieldValue && !field.copyable && shouldDisplayAsHtml"
        v-html="fieldValue"
        ref="iframe_hack_ref"
      />
      <p v-else>&mdash;</p>
    </template>
    <p v-else>&mdash;</p>
  </div>
</template>

<script>
import { CopiesToClipboard, FieldValue } from '@/mixins'

export default {
  mixins: [CopiesToClipboard, FieldValue],

  props: ['resourceName', 'field'],

  methods: {
    copy() {
      this.copyValueToClipboard(this.field.value)
    },
      check_iframe_hack(event) {
        console.log('iframe_hack', event)
          if (event.target.nodeName === 'IMG' && event.target.classList.contains('iframe-trigger')) {
              console.log('iframe_children', this.$refs['iframe_hack_ref'].children)
              let children = this.$refs['iframe_hack_ref'].children
              children[0].classList.remove('hidden')
              children[0].src  = children[0].getAttribute('data-src')
              children[1].remove()
          }
      },
  },
    // mounted: function() {
    //     document.addEventListener('keydown', handleEscape))
    //
    //
    // },
    // beforeUnmount: function () {
    //     document.removeEventListener('keydown', handleEscape))
    // },
}
</script>
